import hotkeys from './hotkeys'

export default {
  hotkeys,
}

export * as hotkeys from './hotkeys'
